(function () {
  const ATTRIBUTE_KEY = 'PO Number';
  let saveTimer = null;

  function getCartUpdateUrl() {
    const root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root
      ? window.Shopify.routes.root
      : '/';

    return root + 'cart/update.js';
  }

  function savePONumber(value) {
    return fetch(getCartUpdateUrl(), {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({
        attributes: {
          [ATTRIBUTE_KEY]: (value || '').trim().slice(0, 50)
        }
      })
    });
  }

  document.addEventListener('input', function (event) {
    const input = event.target.closest('[data-po-number-input]');
    if (!input) return;

    clearTimeout(saveTimer);

    saveTimer = setTimeout(function () {
      savePONumber(input.value);
    }, 400);
  });

  document.addEventListener('change', function (event) {
    const input = event.target.closest('[data-po-number-input]');
    if (!input) return;

    savePONumber(input.value);
  });
})();